export type JsonRecord = Record<string, unknown>;

export type ConfigurationSectionKey =
  | "generalConfig"
  | "shopperApp"
  | "assistApp"
  | "associateConfig";

interface ConfigurationSection {
  key: ConfigurationSectionKey;
  titleKey: string;
  deprecatedFields: readonly string[];
  hiddenFields: readonly string[];
}

export const configurationSections: readonly ConfigurationSection[] = [
  {
    key: "generalConfig",
    titleKey: "operations.configs.editConfig.sections.generalConfig",
    deprecatedFields: ["rfidEnabled", "multiLanguageSupportEnabled", "rfidUrl"],
    hiddenFields: ["enabledLanguage", "enabledLanguages"],
  },
  {
    key: "shopperApp",
    titleKey: "operations.configs.editConfig.sections.shopperApp",
    deprecatedFields: ["displayTryThis"],
    hiddenFields: ["welcomeScreens"],
  },
  {
    key: "assistApp",
    titleKey: "operations.configs.editConfig.sections.assistApp",
    deprecatedFields: [],
    hiddenFields: [],
  },
  {
    key: "associateConfig",
    titleKey: "operations.configs.editConfig.sections.associateConfig",
    deprecatedFields: [],
    hiddenFields: [],
  },
];

const configurationFieldTitleKeys: Record<string, string> = {
  customerId: "customerId",
  customerName: "customerName",
  "generalConfig.rfidEnabled": "generalConfigRfidEnabled",
  "generalConfig.emailInputEnabled": "generalConfigEmailInputEnabled",
  "generalConfig.phoneNumberInputEnabled": "generalConfigPhoneNumberInputEnabled",
  "generalConfig.defaultShopperName": "generalConfigDefaultShopperName",
  "generalConfig.multiLanguageSupportEnabled": "generalConfigMultiLanguageSupportEnabled",
  "generalConfig.logo": "generalConfigLogo",
  "generalConfig.customerEnum": "generalConfigCustomerEnum",
  "generalConfig.customerEnumId": "generalConfigCustomerEnumId",
  "generalConfig.rfidUrl": "generalConfigRfidUrl",
  "generalConfig.enabledLanguages": "generalConfigEnabledLanguages",
  "generalConfig.customerWideDevicePin": "generalConfigCustomerWideDevicePin",
  "generalConfig.v2ProactiveRecommendationsEnabled":
    "generalConfigV2ProactiveRecommendationsEnabled",
  "generalConfig.v2DesignEnabled": "generalConfigV2DesignEnabled",
  "generalConfig.v2LoggerEnabled": "generalConfigV2LoggerEnabled",
  "shopperApp.dressingRoomTimeoutSeconds": "shopperAppDressingRoomTimeoutSeconds",
  "shopperApp.defaultAvatarUrl": "shopperAppDefaultAvatarUrl",
  "shopperApp.logoUrl": "shopperAppLogoUrl",
  "shopperApp.productDescriptionHeader": "shopperAppProductDescriptionHeader",
  "shopperApp.greetingText": "shopperAppGreetingText",
  "shopperApp.displayTryThis": "shopperAppDisplayTryThis",
  "shopperApp.bannerImageUrl": "shopperAppBannerImageUrl",
  "shopperApp.bannerLinkUrl": "shopperAppBannerLinkUrl",
  "shopperApp.budgetEnabled": "shopperAppBudgetEnabled",
  "shopperApp.checkoutRequest": "shopperAppCheckoutRequest",
  "shopperApp.priceEnabled": "shopperAppPriceEnabled",
  "shopperApp.scannerType": "shopperAppScannerType",
  "shopperApp.associateRequestEnabled": "shopperAppAssociateRequestEnabled",
  "shopperApp.proactiveRecommendationsEnabled": "shopperAppProactiveRecommendationsEnabled",
  "shopperApp.inventoryQuantityEnabled": "shopperAppInventoryQuantityEnabled",
  "shopperApp.requestTimerEnabled": "shopperAppRequestTimerEnabled",
  "shopperApp.accessibilityImageUrl": "shopperAppAccessibilityImageUrl",
  "shopperApp.welcomeScreens": "shopperAppWelcomeScreens",
  "assistApp.timeoutSeconds": "assistAppTimeoutSeconds",
  "assistApp.associateRequestEnabled": "assistAppAssociateRequestEnabled",
  "associateConfig.hardwareScanningEnabled": "associateConfigHardwareScanningEnabled",
  "associateConfig.insightsEnabled": "associateConfigInsightsEnabled",
  "associateConfig.requestListType": "associateConfigRequestListType",
  "associateConfig.locatorType": "associateConfigLocatorType",
};

export const getConfigurationFieldTitle = (key: string, translate: (key: string) => string) =>
  translate(
    `operations.configs.editConfig.summaryFields.${configurationFieldTitleKeys[key] ?? "unknown"}`,
  );
